var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"align-center"},[_c('v-col',{attrs:{"cols":"12","md":"9"}},[_vm._v(_vm._s(_vm.title))]),_c('v-col',{staticClass:"text-number admin--text text-end",attrs:{"cols":"12","md":"3"}},[_vm._v(" "+_vm._s(_vm.value)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }